import React, { useState } from 'react'
import Layout from '../../components/layout/Layout'
import useGet from '../../hooks/read/useGet'
import PrimaryLoader from '../../components/common/PrimaryLoader'
import LikertView from '../../components/likert'
import Moment from 'react-moment'
import Spinner from '../../components/loader/Spinner'
import { ClockIcon } from '@heroicons/react/solid'

const ShiftDetails = () => {
    const [isShowWeek, setShowWeek] = useState(false)
    const { list: shiftDetail } = useGet({
        url: 'user_shift_details',
        initialData: {},
        onSuccess: () => {
            setTimeout(() => {
                setShowWeek(true)
            }, 2000)
        }
    })

    const shiftData = shiftDetail.data?.data;
    

    if (shiftDetail.data?.data?.length === 0) {
        return (
            <div className='px-5 py-10'>
                <div className='text-center border border-gray-200 rounded-lg p-8 bg-gray-50'>
                    <ClockIcon className="w-16 h-16 mx-auto text-gray-400 mb-4" />
                    <p className='text-2xl font-medium text-gray-700 mb-2'>No Shift Details Available</p>
                    <p className='text-gray-500'>You don't have any assigned shifts at the moment.</p>
                </div>
            </div>
        )
    }
    
    return (
        <>
            {shiftDetail.isLoading && 
            <div className=' bg-white/90 fixed top-0 left-0 w-full h-full z-30 flex items-center justify-center'> <Spinner />
            </div>}
            <div className='px-5'>
                <div>
                    <p className=' text-2xl font-semibold py-2'>Shift Details</p>
                </div>
                <div className='grid grid-cols-1 lg:grid-cols-3 gap-y-5 gap-x-5 py-5'>
                    <div>
                        <div className=''>
                            <label className='label'>Current Shift: </label>
                            <span className='block font-semibold text-base bg-red-100 text-red-600 py-2 rounded-md text-center'>
                                {shiftDetail.data?.data?.shiftName}
                            </span>
                        </div>
                    </div>
                    <div>
                        <div>
                            <label className='label'>Effected From </label>
                            <p className='input'>
                                <Moment unix format='LL'>
                                    {shiftDetail.data?.data?.from_date}
                                </Moment>
                            </p>
                        </div>
                    </div>
                    <div>
                        <div>
                            <label className='label'>Shift timings </label>
                            <p className='input'>
                                {shiftData?.shiftInTime} - {shiftData?.shiftOutTime}
                                {/* <Moment unix format='LL'>
                                    {shiftDetail.data?.data?.from_date}
                                </Moment> */}
                            </p>
                        </div>
                    </div>
                </div>
                {shiftDetail.data?.data?.shift_type !== 'lenient' &&
                    <div className='py-5'>
                        <p className='text-gray-700 text-3xl font-semibold mb-4'>Weekend Definition</p>
                        {
                            !isShowWeek && shiftDetail.data?.data?.weekendDefinition ? (
                                <div className="flex justify-center items-center py-10">
                                    <div className="flex space-x-5 items-center">
                                        <Spinner size="md" />
                                        <p className="mt-3 text-gray-500">Loading weekend definition...</p>
                                    </div>
                                </div>
                            ) : isShowWeek && (
                                <LikertView
                                    disabled={true}
                                    values={shiftDetail.data?.data?.weekendDefinition}
                                />
                            )
                        }
                    </div>}
            </div>
        </>
    )
}

export default ShiftDetails